import { combineReducers } from '@reduxjs/toolkit';
import { vendorCommentsReducer } from './vendorComments/reducer';
import { vendorOrderReducer } from './vendorOrderData/reducer';
import { vendorDocumentsReducer } from './vendorDocuments/reducer';
import { vendorOrdersReducer } from './vendorOrders/reducer';
import { vendorPayoffsReducer } from './vendorPayoffs/reducer';
import { vendorPayoffReducer } from './vendorPayoffData/reducer';
import { vendorTaxCertificationsSlice } from './vendorTaxCertifications/slices';
import { taxCertificationReducer } from './vendorTaxCertificationData/taxCertificationReducer';

export const vendorReducer = combineReducers({
  comments: vendorCommentsReducer.reducer,
  documents: vendorDocumentsReducer.reducer,
  order: vendorOrderReducer.reducer,
  orders: vendorOrdersReducer.reducer,
  payoff: vendorPayoffReducer.reducer,
  payoffs: vendorPayoffsReducer.reducer,
  taxCertification: taxCertificationReducer,
  taxCertifications: vendorTaxCertificationsSlice.reducer,
});
